// extracted by mini-css-extract-plugin
export default {"add":"InfoModal_add__Hbthx"};